import React, {useState} from "react"
//import containerStyles from "./container.module.css"
import Navbar from "./navbar"
import Sidebar from "./sidebar"
import Page from "./page"
import Footer from "./footer"
import style from "./layout.css"

export default ({ children, components, page, related }) => {

  const [show, setShow] = useState(false);


  const onTouchStart = ()=>{
  }

  const onTouchEnd = ()=>{
  }

  const onToggleSidebar = ()=>{
    setShow(!show);
  }

  return (
    <div
      className="cd-app sidebar-open"
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <Navbar
        onTogglSidebar={onToggleSidebar}
      />
      <Sidebar
        components={components}
        page={page}
        show={show}
        onToggleSidebar={onToggleSidebar}
      />
      <Page
        page={page}
        related={related}
        topSlot='topSlot'
        bottomSlot='bottomSlot'
      >
        {children}
      </Page>
      <Footer />
    </div>
  )

}
